import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid, Image } from "semantic-ui-react";
import placeholderImage from "../../images/forms/placeholderImage.png";
import { Icon } from "semantic-ui-react";

class FormListItem extends Component {
  handleClick(e) {
    this.props.onClick(
      this.props.form_id,
      this.props.form_title,
      this.props.icon_path,
      this.props.form_version,
      this.props.uuid,
      this.props.approval_enabled,
      this.props.notification_id
    );
  }

  createMarkup() {
    const { form_title, container, draftName } = this.props;

    return {
      __html:
        container === "Drafts" ? draftName.replace(", ", "<br />") : form_title
    };
  }

  renderDelete(icon) {
    if (this.props.container !== "Forms")
      return (
        <Icon
          onClick={this.deleteDraft.bind(this)}
          inverted
          style={{
            cursor: "pointer",
            color: "#cfcfcf",
            position: "absolute",
            fontSize: "20px",
            right: 25,
            top: 20,
            zIndex: 10
          }}
          name="remove circle"
        />
      );

    return null;
  }

  deleteDraft() {
    this.props.onDelete(this.props.uuid, this.props.result_id);
  }

  renderImage() {
    const { icon_path } = this.props;

    if (icon_path === null || icon_path === undefined) {
      return (
        <div>
          {this.renderDelete(false)}
          <Image onClick={this.handleClick.bind(this)} src={placeholderImage} />
        </div>
      );
    }

    return (
      <div>
        {this.renderDelete(true)}
        <Image
          onClick={this.handleClick.bind(this)}
          src={icon_path === null ? placeholderImage : icon_path}
        />
      </div>
    );
  }

  renderSaved() {
    if (this.props.container === "Drafts") {
      let mainBgColor = window.shadeBlendConvert(0.2, this.props.storeColour);
      let thumbBgColor = window.shadeBlendConvert(0.8, this.props.storeColour);

      if (this.props.saved) {
        return (
          <Icon
            type="fontawesome"
            style={{
              border: "none",
              padding: 0,
              background: "none",
              color: mainBgColor
            }}
            name="check circle"
            size={16}
          />
        );
      }

      return (
        <Icon
          type="fontawesome"
          style={{
            border: "none",
            padding: 0,
            background: "none",
            color: thumbBgColor
          }}
          name="check circle"
          size={16}
        />
      );
    }
  }

  render() {
    const { icon_path, form_version } = this.props;
    return (
      <Grid.Column className={"formListItem"}>
        {this.renderImage()}
        <div className={"formListItemTitle"}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td>
                  <span
                    dangerouslySetInnerHTML={this.createMarkup()}
                    onClick={this.handleClick.bind(this)}
                  ></span>
                  <br />
                  <span style={{ fontSize: "12px" }}>(v{form_version})</span>
                  <span style={{ fontSize: "16px", float: "right" }}>
                    {this.renderSaved()}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Grid.Column>
    );
  }
}

FormListItem.propTypes = {
  icon_path: PropTypes.string,
  form_title: PropTypes.string.isRequired,
  form_version: PropTypes.string.isRequired,
  form_id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  container: PropTypes.string.isRequired,
  saved: PropTypes.bool
};

export default FormListItem;



// WEBPACK FOOTER //
// ./src/components/FormListItem/index.js